module.exports = __webpack_public_path__ + "img/flag.1c0729da.svg";